module.exports = __webpack_public_path__ + "img/logo1.ca978843.png";